import React from "react";
import { LayoutTemplate } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface DualImageDisplayProps {
  templateUrl?: string | null;
  postUrl?: string | null;
  templateId?: string | null;
}

export const DualImageDisplay: React.FC<DualImageDisplayProps> = ({ templateUrl, postUrl, templateId }) => {
  const navigate = useNavigate();

  const handleTemplateClick = (e: React.MouseEvent) => {
    if (templateId) {
      e.stopPropagation();
      navigate(`/post-generator/templates?templateId=${templateId}`);
    }
  };

  const singleContainerClasses = "w-36 h-36 sm:w-44 sm:h-44 bg-white/5 hover:bg-white/15 backdrop-blur-md rounded-2xl p-1.5 border border-white/10 shadow-xl flex items-center justify-center overflow-hidden relative z-10 shrink-0 mx-auto transition-colors duration-300 ease-in-out";
  const imageClasses = "w-full h-full object-contain rounded-xl";

  if (!templateUrl && !postUrl) {
    return (
      <div className={singleContainerClasses}>
        <LayoutTemplate className="w-10 h-10 text-white/20" />
      </div>
    );
  }

  if (templateUrl && !postUrl) {
    return (
      <div 
        className={`${singleContainerClasses} ${templateId ? 'cursor-pointer' : ''}`}
        onClick={handleTemplateClick}
      >
        <img src={templateUrl} alt="Template Vorschau" className={imageClasses} />
      </div>
    );
  }

  if (!templateUrl && postUrl) {
    return (
      <div className={singleContainerClasses}>
        <img src={postUrl} alt="Post Vorschau" className={imageClasses} />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full pt-1 pb-3 sm:pb-4 pl-4 sm:pl-6">
      <div className="relative w-36 h-36 sm:w-44 sm:h-44">
        {/* Main Result (Post) */}
        <div className="w-full h-full bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-2xl p-1.5 border border-white/20 shadow-xl relative z-10 transition-colors duration-300 ease-in-out">
          <img src={postUrl!} alt="Generierter Post" className={imageClasses} />
        </div>

        {/* Origin Indicator (Template PiP) */}
        <div 
          onClick={handleTemplateClick}
          className={`absolute -bottom-4 -left-6 sm:-bottom-5 sm:-left-8 w-16 h-16 sm:w-20 sm:h-20 bg-black/20 hover:bg-white/15 backdrop-blur-xl rounded-xl p-1 border border-white/20 shadow-2xl z-20 flex items-center justify-center transition-colors duration-300 ease-in-out ${templateId ? 'cursor-pointer' : ''}`}
        >
          <img src={templateUrl!} alt="Original Template" className="w-full h-full object-contain rounded-lg opacity-90" />
        </div>
      </div>
    </div>
  );
};



